































import { Component, Prop, Vue } from "vue-property-decorator";
import ContentRenderComponent from "@/components/render/ContentRender.vue";
import { RenderTemplateModel, RenderContentModel } from "@/services/render/types";
import { renderBackground } from "@/services/render/renderService";
import { Getter } from "vuex-class";
import PreviewFullScreenHeader from "@/components/common/preview/PreviewFullScreenHeader.vue";
import PreviewSidebar from "@/components/common/preview/PreviewSidebar.vue";
const namespace: string = "authentication";

@Component({
    components: {
        ContentRenderComponent,
        PreviewFullScreenHeader,
        PreviewSidebar
    }
})
export default class BackgroundPreview extends Vue {
    @Prop() private backgroundId!: string;
    @Getter("getToken", { namespace }) getToken!: string;

    // local state
    contentRenderModel = {
        height: 0,
        width: 0,
        renderChannels: [] as Array<RenderContentModel>
    } as RenderTemplateModel;

    contentRenderReload = 0;
    scale = 1;
    dateTime = "";
    fitScale = 0;
    bgColor = "#ffffff";

    // lifecycle hooks
    created() {
        this.backgroundId = this.backgroundId
            ? this.backgroundId
            : this.$route.params.backgroundId;
    }

    renderBackground(value: string, keepZoom = false) {
        this.dateTime = value;
        renderBackground(this.backgroundId, this.dateTime).then(
            response => {
                this.contentRenderModel = response;
                const oldScale = this.scale;
                this.setScale();
                if (keepZoom) this.scale = oldScale;
            }
        );
    }

    setScale() {
        var scaleX = (window.innerWidth / 100 * 95) / this.contentRenderModel.width;
        var scaleY = (window.innerHeight / 100 * 88) / this.contentRenderModel.height;
        this.scale = scaleX <= scaleY ? scaleX : scaleY;
        this.scale = this.scale >= 1 ? 1 : this.scale;
        this.scale = Math.floor(this.scale * 100) / 100;
        this.fitScale = this.scale;
    }

    onScale(value: number) {
        this.scale = value;
    }

    changeBg(color: string) {
        this.bgColor = color;
    }

    // computed
    get model(): RenderTemplateModel {
        this.contentRenderReload += 1;
        return this.contentRenderModel;
    }

    get adaptedSize() {
        return {
            transform: "scale(" + this.scale + ")",
            "transform-origin": "left top",
            height: `${this.contentRenderModel.height}px`,
            width: `${this.contentRenderModel.width}px`
        };
    }
}
